export const scrollToFirstError = (errors) => {
  const errorFields = Object.keys(errors);
  if (errorFields.length === 0) return;

  // 첫 번째 오류 필드 찾기 (재귀적으로 중첩된 오류도 처리)
  const findFirstErrorField = (errorObj, path = '') => {
    for (const key in errorObj) {
      const currentPath = path ? `${path}.${key}` : key;
      const error = errorObj[key];

      if (error?.message) {
        return currentPath;
      }

      if (error && typeof error === 'object' && !error.message) {
        const nestedPath = findFirstErrorField(error, currentPath);
        if (nestedPath) return nestedPath;
      }
    }
    return null;
  };

  const firstErrorField = findFirstErrorField(errors) || errorFields[0];
  console.log('First error field:', firstErrorField);

  // 필드 이름 정규화 (배열 인덱스 제거, 예: evidence.0.type -> evidence)
  const normalizedFieldName = firstErrorField.split('.')[0];

  // MUI FormHelperText를 먼저 찾기 (가장 확실한 방법)
  const errorTexts = document.querySelectorAll('.MuiFormHelperText-root.Mui-error');
  let targetElement = null;
  let scrollTarget = null;

  if (errorTexts.length > 0) {
    // 첫 번째 에러 메시지의 부모 컨테이너 찾기
    const firstErrorText = errorTexts[0];
    const errorContainer = firstErrorText.closest('div.flex.flex-col');

    if (errorContainer) {
      // input, textarea, select 요소 찾기
      targetElement = errorContainer.querySelector('input, textarea, select');

      // article이나 section 찾기
      scrollTarget = errorContainer.closest('article') || errorContainer.closest('section') || errorContainer;
    }
  }

  // FormHelperText로 찾지 못한 경우 다른 방법 시도
  if (!targetElement) {
    // 1. name 속성으로 직접 찾기
    targetElement = document.querySelector(
      `input[name="${firstErrorField}"], textarea[name="${firstErrorField}"], select[name="${firstErrorField}"]`,
    );

    // 2. 정규화된 필드 이름으로 찾기
    if (!targetElement) {
      targetElement = document.querySelector(
        `input[name="${normalizedFieldName}"], textarea[name="${normalizedFieldName}"], select[name="${normalizedFieldName}"]`,
      );
    }

    // 3. id 속성으로 찾기
    if (!targetElement) {
      targetElement = document.getElementById(firstErrorField) || document.getElementById(normalizedFieldName);
    }

    // 4. data-name 속성으로 찾기 (Controller 사용 시)
    if (!targetElement) {
      targetElement =
        document.querySelector(`[data-name="${firstErrorField}"]`) ||
        document.querySelector(`[data-name="${normalizedFieldName}"]`);
    }

    if (targetElement) {
      scrollTarget =
        targetElement.closest('article') ||
        targetElement.closest('section') ||
        targetElement.closest('div.flex.flex-col') ||
        targetElement.parentElement ||
        targetElement;
    }
  }

  if (scrollTarget) {
    // 스크롤 위치 계산 (120px 보정)
    // requestAnimationFrame을 사용하여 브라우저 기본 동작 이후에 실행
    requestAnimationFrame(() => {
      // 약간의 딜레이 후 우리의 스크롤 실행
      setTimeout(() => {
        const elementPosition = scrollTarget.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 120;

        window.scrollTo({
          top: Math.max(0, offsetPosition), // 음수 방지
          behavior: 'smooth',
        });

        // 포커스 설정
        if (targetElement && targetElement.focus && targetElement.tagName !== 'DIV') {
          setTimeout(() => {
            targetElement.focus();
          }, 500);
        }
      }, 50);
    });
  } else {
    console.warn('Could not find error field element for:', firstErrorField);
  }
};
